module.exports = __webpack_public_path__ + "static/template-home-hero-background-5585223beb09d782dac2f90fdbcadcbe.jpg";